<div class="titleBox"> <h1 style="text-align: center">Subdivisions</h1></div>
<div><hr></div>
<br>
<br>
<button mat-raised-button (click)="addSubdivisionDialog()"> Add New Subdivision</button>
      <ngx-table [configuration] = "configuration"  [data]="gridEntrie$ | async" [columns]= "columns" [loadingTemplate] = "loadingTemplate" >
          <ng-template let-row>
            <td>
              <div>
                {{row.subdivision_name}}
              </div>
            </td>

            <td>
                <div>
                  {{row.scope}}
                </div>
            </td>

            <!-- Cells are matched to `columns` POSITIONALLY, so these must stay in
                 lockstep with the 'scope2'/'scope3' entries in subdivisions.component.ts. -->
            <td>
                <div>
                  {{row.scope2}}
                </div>
            </td>

            <td>
                <div>
                  {{row.scope3}}
                </div>
            </td>

            <td>
                <div>
                  {{row.city}}
                </div>
            </td>

            <td>
                <div>
                  {{row.state}}
                </div>
            </td>

            <td>
              <div>
                {{row.region}}
              </div>
            </td>

            <td>
              <div style="text-align: center;">
                {{row.cz}}
              </div>
            </td>

            <td>
              <div>
                {{row.customer_name}}
              </div>
            </td>

            <td>
                <div>
                  <button button mat-raised-button color="green" (click)="openDialog(row, 1)">
                    <fa-icon [icon]="faedit"></fa-icon>
                  </button>
                </div>
            </td>

            <td>
              <div>
                <button mat-button color="warn" (click)="deleteSubdivision(row)">
                  <fa-icon [icon]="fatrash"></fa-icon>
                </button>
              </div>
          </td>


          <td>
            <div>
              <button mat-button color="black" (click)="copySubdivision(row)">
                <fa-icon [icon]="facopy"></fa-icon>
              </button>
            </div>
        </td>


          </ng-template>
        </ngx-table>






<ng-template #loadingTemplate>
  <td [attr.colspan]="columns.length">
    <div style= "width: 100%; text-align: center">
      <div style="display: inline-block; margin: auto; padding: 3px">
          <div class="lds-ripple"><div></div><div></div>Loading...</div>
      </div>
    </div>
  </td>
</ng-template>


<!--
<table mat-table [dataSource]="contacts$ | async">
-->
<!--
  <mat-input-container>
    <input matInput placeholder="Search lessons" #input>
</mat-input-container>
-->

<!--
    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> Name </th>
        <td mat-cell *matCellDef="let contact"> {{contact.name}} </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef> Email </th>
        <td mat-cell *matCellDef="let contact"> {{contact.email}} </td>
      </ng-container>

      <ng-container matColumnDef="phone">
        <th mat-header-cell *matHeaderCellDef> Phone </th>
        <td mat-cell *matCellDef="let contact"> {{contact.phone}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click) = "onRowClicked(row)"></tr>


</table>

-->

<!--
   <li *ngFor="let contact of contacts">
  <p>{{contact.name}}</p>
  <p>{{contact.email}}</p>
  <p>{{contact.phone}}</p>
</li>

-->
